<script setup lang="ts">
import Avatar from 'primevue/avatar';

import { useAvatar } from '../composables/useAvatar';

const { label } = useAvatar();
</script>

<template>
  <Avatar shape="circle" :label="label" size="large" />
</template>
